import React, {useState, useEffect} from "react";
import { useHistory, Link } from "react-router-dom";
import { observer } from "mobx-react-lite";
import useStore from "stores";

import VopHeader from "components/vop_header";
import VopFooter from "components/vop_footer";
import HomeHeader from "components/HomeHeader"
import FeedBack from "components/vop_feedback";
import SurveyInfo from "components/vop_surveyInfo";
import { loginUrl } from "utils/api/ajax";
import { queryComponentGroup, queryComponentListByGroupId} from "utils/api/index";
import "./style.scss";

const ComponentList = observer(() => {
  const [empty, setEmpty] = useState(null);
  const { loginStore } = useStore();
  const [headerData, setHeaderData] = useState({
    bgColor: "linear-gradient(180deg, rgba(7,7,7,1) 0%,rgba(3,3,3,0) 100%)",
  });
  const [activeNav, setActiveNav] = useState('floor-1');
  const [navData, setNavData] = useState([]);
  const [listData, setListData] = useState([]);

  const history = useHistory();

  useEffect(()=>{
    document.title = "京东VOP开放平台-门户";
    window.scrollTo(0, 0);
    window.onscroll = () => {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if(scrollTop > 50) {
        setHeaderData({
          bgColor: "#000",
        });
      } else {
        setHeaderData({
          bgColor:
            "linear-gradient(180deg, rgba(7,7,7,1) 0%,rgba(3,3,3,0) 100%)",
        });
      }
    }
  },[])
  useEffect(()=>{
    if (empty == null) {
      queryComponentGroup().then(async(res) => {
        if( res?.data?.success ) {
          const listarr = []
          for(var i = 0; i < res.data.result.length; i++){
          // res.data.result.forEach(async(item, i) => {
            let item = res.data.result[i]
            item.floorId = 'floor-'+ (i+1)
            const reason = await queryComponentListByGroupId({componentGroupId: item.componentGroupId});
            // console.log('reason', reason)
            if( reason?.data?.success &&  reason?.data?.result) {
              reason.data.result[0].floorId = 'floor-'+ (i+1)
              reason.data.result.forEach((list, index) => {
                // console.log('list', list)
                listarr.push(list)
              })
            }
            // console.log('listarr', listarr)
            setListData(listarr)
          // });
          }
          // console.log('listarr222222', listarr)
          setNavData(res.data.result)
          setEmpty(!res.data.result);
          // console.log('listData', listData)

        }
      });
    }
    window.addEventListener("scroll", pageScroll)
  },[empty])
  
  const compare = (prop) => {
    return function(a, b) {
      const value1 = a[prop];
      const value2 = b[prop];
      return value1 - value2;
    }
  }

  let scrollTimer
  const pageScroll =()=> {
    if(navData && navData.length && navData.length > 0) {
      if(scrollTimer) {
        clearTimeout(scrollTimer)
      }
      scrollTimer = setTimeout(() => {
        // console.log('scroll navData', navData)
        // const firstTop = document.getElementById('floor-1')?.getBoundingClientRect()?.top;
        // console.log('firstTop', firstTop)
        // if(firstTop && firstTop < 10) {
        //   setIsSticky(true)
        // } else {
        //   setIsSticky(false)
        // }
        const eleTop = [];
        for(const i in navData) {
          const id = navData[i].floorId;
          const ele = document.getElementById(id);
          if (!ele) return;
          const top = ele.getBoundingClientRect().top + 155; // 减去tab高度
          // console.log('top', ele, top)
          // if(top < 300) continue;
          if(top < 300){
            eleTop.push({id, top})
          }
        }
        eleTop.sort(compare("top"))
        // console.log('eleTop3', eleTop)
        if(eleTop[eleTop.length - 1] && eleTop[eleTop.length - 1].id) {
          setActiveNav(eleTop[eleTop.length - 1].id)
        }
      }, 20)
    }
  }

  const componentSide = (value) => {
    if(value.includes('1') && value.includes('2') && value.includes('3')) {
      return 'PC端 移动端 小程序'
    } else if(value.includes('1') && value.includes('2')) {
      return 'PC端 移动端'
    } else if(value.includes('1') && value.includes('3')) {
      return 'PC端 小程序'
    } else if(value.includes('2') && value.includes('3')) {
      return '移动端 小程序'
    } else if(value.includes('1')) {
      return 'PC端'
    } else if(value.includes('2')) {
      return '移动端'
    } else if(value.includes('3')) {
      return '小程序'
    }
  }

  const handleClick = (activeItem) => {
    console.log('activeItem', activeItem)
    // window.removeEventListener("scroll", pageScroll)
    if(activeItem) {
      setActiveNav(activeItem.floorId)
      // console.log('activeNav', activeItem.floorId)
      let top = document.getElementById(`${activeItem.floorId}`).offsetTop - 135;
      window.scroll({
        top: top, 
        behavior: 'smooth', 
      });
    }
    console.log('activeNav', activeNav)
    // window.addEventListener("scroll", pageScroll)
  }

  const toDetail = (item) => {
    log("VopOpenIndex_1602911919488", '38');
    history.push(
      `/component/details?componentIndexName=${item.componentIndexName}`
    );
  }

  return (
    <div className="component-wrap component-page">
      <div className="component-box">
        <VopHeader {...headerData} contentWidth="1200px">
            <HomeHeader />
        </VopHeader>
      </div>
      <div className="component-box component-banner">
        <img src="https://img11.360buyimg.com/imagetools/jfs/t1/195117/2/24831/1551880/6280834aE0a5329c0/cb42605f7bc1703f.png!cc_1536x321" />
        <div className="content">
          <h3 className="title">组件服务列表</h3>
          <Link 
            className="btn" 
            to={loginStore.isLogin ? "/app/frame" : loginUrl} 
            clstag="pageclick|keycount|VopOpenIndex_1602911919488|37" 
          >
            前去订阅
          </Link>
          
        </div>
      </div>
      <div className={`component-box component-nav sticky`}>
        <ul className="nav-list">
          {
            !empty && navData.map((item, index) => {
              return <li className={`nav-item nav-item-${index} ${activeNav === item.floorId ? 'cur' : ''}`} onClick={ () => { handleClick(item, index) } } key={index}>
                {item.componentGroupName}
              </li>
            })
          }
        </ul>
      </div>
      <div className="component-box component-list">
      {/* {console.log('dom listData', listData)} */}
        {
          listData.map((item, index) => {
            return (
                <div className={`list-box ${item.componentState == 2 ? '' : 'disabled'}`} id={item.floorId} key={index}>
                  <div className="img-box">
                    <img src={item.componentIcon} />
                    { item.componentState != 2 && 
                      <div className="wait">敬请期待</div>
                    }
                  <div className="label">{item.componentGroupName}</div>
                </div>
                <div className="content-box">
                  <h4 className="title">{item.componentIndexName}</h4>
                  <p className="desc">{item.componentDesc}</p>
                  <p className="content">{item.componentContent}</p>
                  <div className="bottom-box">
                    { componentSide(item.supportSide) && componentSide(item.supportSide).length > 0 && <span className="sence">支持{componentSide(item.supportSide)}</span>}
                    { item.componentState == 2 && 
                      <div 
                        className="more" 
                        onClick={()=>{toDetail(item)}}
                      >
                        了解更多<i className="icon-more"></i>
                      </div>
                    }
                  </div>
                </div>
              </div>
            )
          })
        }
      </div>
      <div className="jdw-container">
        <div className="jdw-row">
          <div className="jdw-column">
            <div
              className="jdw-widget"
              data-name="vop_footer"
              data-version="2.0.0"
            >
              <VopFooter />
            </div>
          </div>
        </div>
      </div>
      <FeedBack></FeedBack>
      <SurveyInfo></SurveyInfo>

    </div>
  );
});

export default ComponentList;
